/* Reusable Product Landing — section interactivity (carousel, bundle toggle,
   game tabs, compatibility checker, FAQ). Vanilla JS, no framework.
   Binds by CSS class and scopes to each .lg-lp root, so multiple instances
   (and any landing built from the section) work independently. */
(function () {
  function init(root) {
    if (!root || root.__lgInit) return;
    root.__lgInit = true;

    var ORANGE = 'var(--osmo-orange)';

    /* ---------- Bundle selector ---------- */
    var kitBtns = qa(root, '.lg-kit');
    var buyBoxes = qa(root, '.lg-buybox');
    var secBuys = qa(root, '.lg-secondary-buy');
    var stickyPrice = q(root, '.lg-sticky-price');
    var stickyWas = q(root, '.lg-sticky-was');
    var secPrice = q(root, '.lg-sec-price');
    var selKitBtn = kitBtns.filter(function (b) { return b.classList.contains('sel'); })[0];
    var currentKit = (selKitBtn && selKitBtn.dataset.kit) || '4';

    function selectKit(kit) {
      currentKit = kit;
      var btn = kitBtns.filter(function (b) { return b.dataset.kit === kit; })[0];
      kitBtns.forEach(function (b) { b.classList.toggle('sel', b.dataset.kit === kit); });
      buyBoxes.forEach(function (x) { x.classList.toggle('lg-active', x.dataset.kit === kit); });
      if (btn) {
        if (stickyPrice) stickyPrice.textContent = btn.dataset.price || '';
        if (stickyWas) stickyWas.textContent = btn.dataset.was || '';
        if (secPrice) secPrice.textContent = btn.dataset.price || '';
        /* 2026-09-30: en los kits que tienen version iPad y version Fire, la barra dice cual
           de las dos se esta comprando. El nombre del dispositivo viaja en data-device del
           propio elemento y no en este archivo, que es compartido por landings sin hermana. */
        var sk = q(root, '.lg-sticky-kit');
        if (sk) {
          var skDev = sk.getAttribute('data-device');
          var skKey = (sk.getAttribute('data-device-key') || '').toLowerCase();
          var skTxt = btn.dataset.sticky || (kit + '-Game Bundle');
          /* La decision se rehace con el texto de ESTE kit: si el nombre del bundle ya nombra la
             tablet no se repite el sufijo. Antes se decidia una sola vez en Liquid, con el texto
             del kit por defecto, y al cambiar de bundle quedaba pegada la decision equivocada. */
          /* Se busca la PALABRA, no la cadena: 'fire' pelado da positivo dentro de "Bonfire".
             El espacio adelante matchea "for Fire" y "Fire tablet" pero no "bonfire". */
          if (skDev && (!skKey || (' ' + skTxt.toLowerCase()).indexOf(' ' + skKey) === -1)) skTxt += ' for ' + skDev;
          sk.textContent = skTxt + ' selected';
        }
        secBuys.forEach(function (a) { a.setAttribute('href', a.getAttribute('data-url-' + kit) || a.getAttribute('href')); });
        // Main "Buy it now" CTAs: update href (cart permalink) and price for the selected bundle
        qa(root, '.lg-cta-main').forEach(function (a) { if (btn.dataset.href) a.setAttribute('href', btn.dataset.href); });
        qa(root, '.lg-cta-price').forEach(function (s) { if (btn.dataset.price) s.textContent = btn.dataset.price; });
      }
      // Bundle-variant swaps: media (e.g. kit photo) and text (e.g. "4/6 learning games")
      qa(root, '[data-src-6]').forEach(function (el) {
        var base = el.getAttribute('data-src-base'), alt = el.getAttribute('data-src-6');
        var nv = (kit === '6' && alt) ? alt : base;
        if (nv && el.getAttribute('src') !== nv) el.setAttribute('src', nv);
      });
      qa(root, '[data-text-6]').forEach(function (el) {
        var base = el.getAttribute('data-text-base'), alt = el.getAttribute('data-text-6');
        el.textContent = (kit === '6' && alt) ? alt : (base || el.textContent);
      });
      // Comparison table above the selector: tint the column of the SELECTED bundle
      qa(root, '.lg-bx-table').forEach(function (t) {
        t.classList.remove('k4', 'k6'); t.classList.add('k' + kit);
      });
      // (game tabs no longer re-render on bundle switch: all six always show)
    }
    kitBtns.forEach(function (b) { b.addEventListener('click', function () { selectKit(b.dataset.kit); }); });

    /* ---------- Hero carousel ---------- */
    (function () {
      var car = q(root, '.lg-carousel'); if (!car) return;
      var slides = qa(car, '.lg-slide');
      var dotsWrap = q(root, '.lg-dots');
      var thumbsWrap = q(root, '.lg-thumbs');
      if (!slides.length || (!dotsWrap && !thumbsWrap)) return;
      var idx = 0;
      /* mp4 slides are wrappers (like the YouTube slide) with the <video> and a play button INSIDE, so the
         button travels with the slide during swipes. No autoplay: poster + button; tapping is a user gesture,
         so playback starts WITH sound. */
      function vidEl(sl) { return sl ? (sl.tagName === 'VIDEO' ? sl : q(sl, 'video')) : null; }
      function syncPlayBtn() {
        slides.forEach(function (sl) {
          if (sl.dataset.type !== 'video') return;
          var b = q(sl, '.lg-vid-play'), vv = vidEl(sl);
          if (b && vv) b.style.display = vv.paused ? 'flex' : 'none';
          var sb = q(sl, '.lg-vid-sound'); if (sb && vv) sb.style.display = (!vv.paused && vv.muted) ? 'inline-flex' : 'none';
        });
      }
      qa(car, '.lg-slide[data-type=\"video\"]').forEach(function (sl) {
        if (sl.tagName === 'VIDEO') return;
        /* Video con controles nativos (controls): el navegador es dueno de los toques (play/pausa/scrub), asi que
           el slide no interviene; el sonido se activa con el chip .lg-vid-sound o con el mute del control. */
        var cv = vidEl(sl); if (cv && cv.controls) return;
        sl.addEventListener('click', function (ev) {
          if (ev.target.closest('.lg-vid-play')) return;
          var vv = vidEl(sl); if (!vv) return;
          /* Slide con autoplay (data-autoplay): el primer toque activa el sonido en vez de pausar. */
          if (sl.dataset.autoplay && !vv.paused && vv.muted) { vv.muted = false; sl.dataset.userSound = '1'; syncPlayBtn(); return; }
          if (!vv.paused) { try { vv.pause(); } catch (e) {} }
        });
      });
      qa(car, '.lg-vid-sound').forEach(function (b) {
        b.addEventListener('click', function (ev) {
          ev.stopPropagation();
          var sl = b.parentElement, vv = vidEl(sl); if (!vv) return;
          vv.muted = false; sl.dataset.userSound = '1'; syncPlayBtn();
        });
      });
      qa(car, '.lg-vid-play').forEach(function (b) {
        b.addEventListener('click', function (ev) {
          ev.stopPropagation();
          var sl = b.parentElement, vv = vidEl(sl); if (!vv) return;
          vv.muted = false;
          try { var _pp = vv.play(); _pp && _pp.catch && _pp.catch(function () {}); } catch (e) {}
          b.style.display = 'none';
        });
      });
      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.setAttribute('aria-label', 'Go to image ' + (i + 1));
          d.style.cssText = 'width:9px;height:9px;border-radius:999px;border:none;padding:0;cursor:pointer;background:#d8c4ad;';
          d.addEventListener('click', function () { go(i); });
          dotsWrap.appendChild(d);
        });
      }
      var dots = dotsWrap ? qa(dotsWrap, 'button') : [];
      /* Thumbnail strip (Liquid-rendered so the thumbs download before this script runs). */
      var thumbs = thumbsWrap ? qa(thumbsWrap, '.lg-thumb') : [];
      /* La tira Liquid re-deriva la lista de slides; si alguna configuracion los desalinea (metafield hero,
         video de Files, youtube_id vacio...), esconderla es mejor que navegar mintiendo (review PR #83). */
      if (thumbs.length && thumbs.length !== slides.length) { thumbsWrap.style.display = 'none'; thumbs = []; }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      function go(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          var on = i === idx;
          s.style.opacity = on ? '1' : '0'; s.style.zIndex = on ? '1' : '0';
          if (s.dataset.type === 'video') {
            var vv = vidEl(s);
            if (vv) {
              if (!on) { try { vv.__prog = true; vv.pause(); } catch (e) {} }
              else if (s.tagName === 'VIDEO') { vv.muted = true; try { vv.currentTime = 0; var _pp = vv.play(); _pp && _pp.catch && _pp.catch(function () {}); } catch (e) {} }
              /* Autoplay wrapper slide: NO se reanuda si el usuario lo pauso desde los controles nativos (data-userPaused,
                 review PR #106); un pause programatico (go() al salir del slide, IntersectionObserver) no cuenta. */
              else if (s.dataset.autoplay && !s.dataset.userPaused) { if (!s.dataset.userSound) vv.muted = true; try { var _pa = vv.play(); _pa && _pa.catch && _pa.catch(function () {}); } catch (e) {} }
            }
          }
        });
        dots.forEach(function (d, i) { d.style.width = i === idx ? '22px' : '9px'; d.style.background = i === idx ? ORANGE : '#d8c4ad'; });
        thumbs.forEach(function (t, i) {
          var on = i === idx;
          t.style.borderColor = on ? ORANGE : 'transparent';
          t.style.opacity = on ? '1' : '.7';
          t.setAttribute('aria-current', on ? 'true' : 'false');
        });
        var at = thumbs[idx];
        if (at && thumbsWrap && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
          var l = at.offsetLeft, w = at.offsetWidth, sl = thumbsWrap.scrollLeft, cw = thumbsWrap.clientWidth;
          if (l < sl) thumbsWrap.scrollTo({ left: l - 12, behavior: 'smooth' });
          else if (l + w > sl + cw) thumbsWrap.scrollTo({ left: l + w - cw + 12, behavior: 'smooth' });
        }
        syncPlayBtn();
      }
      var prev = q(root, '.lg-prev'), next = q(root, '.lg-next');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      /* No self-advancing of any kind: a finished video just stops. (The timer-based autoplay only ever
         existed in the paid lander's forked JS, not here.) */
      slides.forEach(function (s) { if (s.dataset.type === 'video') { var vv = vidEl(s); if (vv) { vv.loop = false; vv.addEventListener('ended', syncPlayBtn);
        /* pause: si no vino de go()/IO (vv.__prog) fue el usuario desde los controles nativos -> go() no lo reanuda. */
        vv.addEventListener('pause', function () { if (vv.__prog) { vv.__prog = false; } else if (!vv.ended) { s.dataset.userPaused = '1'; } syncPlayBtn(); });
        /* Controles nativos: si el usuario quita el mute desde la barra, recordarlo (go() no lo vuelve a silenciar) y
           esconder el chip; un slide sin autoplay que arranca desde el play nativo suena (es un gesto del usuario).
           El IntersectionObserver silencia al salir de pantalla: al volver a darle play se restaura el sonido elegido
           (userSound) en vez de quedar mudo (review PR #106). */
        vv.addEventListener('volumechange', function () { if (!vv.muted) s.dataset.userSound = '1'; syncPlayBtn(); });
        vv.addEventListener('play', function () { s.dataset.userPaused = ''; if (vv.controls && (!s.dataset.autoplay || s.dataset.userSound)) vv.muted = false; syncPlayBtn(); });
      } } });
      swipe(car, function (dir) { go(idx + dir); });
      /* El boton de mute historico se elimino: ningun consumidor renderiza .lg-mute (review PR #83). */
      if ('IntersectionObserver' in window) { new IntersectionObserver(function (en) { var sAct = slides[idx], v = vidEl(sAct); if (!sAct || sAct.dataset.type !== 'video' || !v) return; if (!en[0].isIntersecting) { v.muted = true; try { v.__prog = true; v.pause(); } catch (e) {} } }, { threshold: 0.25 }).observe(car); }
      go(0);
    })();

    /* ---------- Game tabs + video ---------- */
    var GAMES = [];
    try { GAMES = JSON.parse(q(root, '.lg-games-data').textContent); } catch (e) {}
    var gameVideo = q(root, '.lg-game-video');
    var gameName = q(root, '.lg-game-name');
    var gameSkill = q(root, '.lg-game-skill');
    var tabsWrap = q(root, '.lg-game-tabs');
    var activeGame = (GAMES[0] || {}).key;
    var gameSeen = false;  // defer the game video download until its section is in view

    /* All six games always show. The last two carry an "Early Math" badge instead of being hidden on the
       4-game bundle: they are paid add-ons, not bonuses, and hiding them undersold the 6-pack. */
    function visibleGames() { return GAMES; }
    function setGame(key) {
      var list = visibleGames();
      var g = list.filter(function (x) { return x.key === key; })[0] || list[0];
      if (!g) return;
      activeGame = g.key;
      if (gameSeen && gameVideo && gameVideo.getAttribute('src') !== g.video) { gameVideo.setAttribute('src', g.video || ''); gameVideo.muted = true; try { var _pp = gameVideo.play(); _pp && _pp.catch && _pp.catch(function () {}); } catch (e) {} }
      if (gameName) gameName.textContent = g.name;
      if (gameSkill) gameSkill.textContent = g.skill;
      qa(tabsWrap, '.lg-game-btn').forEach(function (b) {
        var on = b.dataset.key === g.key;
        b.classList.toggle('sel', on);
        var ico = q(b, '.lg-game-ico'); var lbl = q(b, '.lg-game-lbl');
        if (ico) ico.style.boxShadow = on ? '0 0 0 4px ' + ORANGE : '0 0 0 2px #ececec';
        if (ico) ico.style.transform = on ? 'translateY(-3px) scale(1.1)' : 'scale(0.88)';
        if (lbl) { lbl.style.opacity = on ? '1' : '.6'; lbl.style.color = on ? ORANGE : '#1a1a1a'; }
      });
    }
    /* The six games render inside two labelled panels - the four Starter Kit games and the two Early
       Math Adventure games - so the grouping is visual, not a caption. The panel labels mirror the bundle
       selector's card names on purpose. */
    function renderGameTabs() {
      if (!tabsWrap) return;
      tabsWrap.innerHTML = '';
      var groups = [
        { cls: 'lg-ggroup-4', label: (tabsWrap.getAttribute('data-label-4') || '4 Games'), games: GAMES.filter(function (g) { return !g.bonus; }) },
        { cls: 'lg-ggroup-6', label: (tabsWrap.getAttribute('data-label-6') || '6 Games'), games: GAMES.filter(function (g) { return g.bonus; }) }
      ];
      groups.forEach(function (gr) {
        if (!gr.games.length) return;
        var wrap = document.createElement('div');
        wrap.className = 'lg-ggroup ' + gr.cls;
        var row = document.createElement('div');
        row.className = 'lg-ggroup-row';
        gr.games.forEach(function (g) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'lg-game-btn'; b.dataset.key = g.key; b.setAttribute('aria-label', g.name);
          b.style.cssText = 'position:relative;background:none;border:none;padding:0;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:7px;flex:1 1 0;min-width:0;max-width:92px;';
          b.addEventListener('mouseenter', function(){ var i=q(b,'.lg-game-ico'); if(i && !b.classList.contains('sel')) i.style.transform='translateY(-2px) scale(0.92)'; });
          b.addEventListener('mouseleave', function(){ var i=q(b,'.lg-game-ico'); if(i && !b.classList.contains('sel')) i.style.transform='scale(0.88)'; });
          b.innerHTML =
            '<span class="lg-game-ico" style="position:relative;width:100%;aspect-ratio:1/1;border-radius:20px;overflow:hidden;display:block;box-shadow:0 0 0 2px #ececec;transition:box-shadow .14s,transform .14s;">' +
              '<img src="' + (g.icon || '') + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">' +
            '</span>' +
            '<span class="lg-game-lbl" style="font-family:var(--font-display);font-weight:600;font-size:clamp(11px,2.8vw,13px);line-height:1.15;color:#1a1a1a;text-align:center;transition:opacity .14s;">' + g.name + '</span>';
          b.addEventListener('click', function () { setGame(g.key); });
          row.appendChild(b);
        });
        var lbl = document.createElement('span');
        lbl.className = 'lg-ggroup-lbl';
        lbl.textContent = gr.label;
        wrap.appendChild(row); wrap.appendChild(lbl);
        tabsWrap.appendChild(wrap);
      });
      if (!GAMES.some(function (g) { return g.key === activeGame; })) activeGame = (GAMES[0] || {}).key;
      setGame(activeGame);
    }
    var stage = q(root, '.lg-game-stage');
    if (stage) swipe(stage, function (dir) {
      var list = visibleGames(); if (!list.length) return;
      var i = list.findIndex(function (g) { return g.key === activeGame; });
      setGame(list[(i + dir + list.length) % list.length].key);
    });
    renderGameTabs();

    /* ---------- Load + play the game video only while its section is on-screen ---------- */
    if (stage && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        if (!gameVideo) return;
        if (en[0].isIntersecting) {
          if (!gameSeen) { gameSeen = true; setGame(activeGame); }  // first download happens here, in view
          else { try { var _pp = gameVideo.play(); _pp && _pp.catch && _pp.catch(function () {}); } catch (e) {} }
        } else { try { gameVideo.pause(); } catch (e) {} }
      }, { threshold: 0.2 }).observe(stage);
    } else { gameSeen = true; setGame(activeGame); }

    /* "Will my iPad work?" checker is self-contained inline in the section markup. */

    /* ---------- FAQ accordion ---------- */
    qa(root, '.lg-faq').forEach(function (item) {
      var q1 = q(item, '.lg-faq-q'), a = q(item, '.lg-faq-a'), sign = q(item, '.lg-faq-sign');
      if (!q1 || !a) return;
      q1.setAttribute('aria-expanded', 'false');
      q1.addEventListener('click', function () {
        var open = a.style.display === 'block';
        a.style.display = open ? 'none' : 'block';
        q1.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (sign) sign.textContent = open ? '+' : '–';
      });
    });

    /* How Osmo works animation is self-contained in the section markup. */

    /* ---------- bottom padding so sticky bar never covers content ---------- */
    if (q(root, '.lg-sticky')) root.style.paddingBottom = '84px';
  }

  function q(r, s) { return r.querySelector(s); }
  function qa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function swipe(el, cb) {
    var x0 = null;
    /* Un arrastre que empieza sobre la barra de controles nativos de un <video controls> (scrub, volumen) no es un
       swipe: los toques del shadow DOM llegan retargeteados al <video>, asi que se ignora la franja inferior (review PR #106). */
    function onControls(e) { var t = e.target, v = t && t.closest ? t.closest('video[controls]') : null; if (!v) return false; var r = v.getBoundingClientRect(); return e.changedTouches[0].clientY > r.bottom - 72; }
    el.addEventListener('touchstart', function (e) { x0 = onControls(e) ? null : e.changedTouches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) cb(dx < 0 ? 1 : -1); }, { passive: true });
  }

  qa(document, '.lg-lp').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.lg-lp'); if (r) init(r); });
})();
